<div class="col itemsContainer d-print-block-visible" [ngClass]="{'display-therapist-notes': displayTherapistNotes}">
    <div class="row report-controls">
        <div class="col-2" *ngIf="showCommandButtons()">
            <input class="btn btn-primary" type="button" (click)="goBack()" value="Back" />
        </div>
        <div [ngClass]="{'col-8': showCommandButtons(),  'col-12 text-center': !showCommandButtons()}">
            <h1 class="h1-responsive report-name text-center">{{result?.assessment.name}}</h1>
        </div>
        <div class="col-2 ml-auto" *ngIf="showCommandButtons()">
            <input class="btn btn-secondary" type="button" (click)="print()" value="Download PDF" />
        </div>
    </div>
    <div class="row" *ngIf="!hasLoadedResults">
        <div class="col">
            <p class="alert alert-warning">
                <app-spin-icon></app-spin-icon> Loading Report data...</p>
        </div>
    </div>
    <div class="row d-print-block-visible" *ngIf="hasLoadedResults">
        <div class="col d-print-block-visible">
            <div class="row mb-3">
                <div class="card card-cascade wider col">
                    <div class="view gradient-card-header primary-gradient white-text">
                        <h3 class="h3-responsive text-center">Summary</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <app-scale-results-table-summary class="col" [scaleResults]="scaleResults"></app-scale-results-table-summary>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <app-therapist-scale-results class="col" [resultTitle]="'Detailed Responses'" [assessmentResult]="result" [scaleResults]="scaleResults"></app-therapist-scale-results>
            </div>
        </div>
    </div>
</div>
<dac-print-dialog [isOpen]="showPrintDialog" (close)="closePrintDialog()"></dac-print-dialog>


// WEBPACK FOOTER //
// ./src/app/reports/assessment-result-view/assessment-result-view.component.html